// Copyright (c) 2026 SoundDrift. All rights reserved.

import React from 'react';
import { APP_VERSION } from '../../utils/version.js';

export default function VersionTag({ style = {} }) {
  return (
    <div
      data-testid="corner-version-tag"
      style={{
        position: 'fixed',
        bottom: 6,
        right: 10,
        fontSize: '0.65rem',
        fontFamily: "var(--sd-font-mono, 'IBM Plex Mono'), monospace",
        opacity: 0.35,
        color: 'var(--sd-dim, #6E7982)',
        zIndex: 5,
        pointerEvents: 'none',
        userSelect: 'none',
        ...style
      }}
    >
      {APP_VERSION}
    </div>
  );
}
